import { mergeProps } from '@creator/ui/utils/merge-props/merge-props';
import { ensureTokenUrl } from '@src/model/config/helpers';
import type { FC } from 'react';
import { Link, type LinkProps } from 'react-router';
import ProfileImage, { type ProfileImageProps } from './ProfileImage';

export interface ProfileImageWithLinkProps {
    className?: string;
    profileImageProps: ProfileImageProps;
    linkProps?: Partial<LinkProps>;
}

const ProfileImageWithLink: FC<ProfileImageWithLinkProps> = props => {
    const { profileImageProps } = props;

    function renderContent() {
        const { linkProps = {} } = props;
        const { displayName, tokenName = '' } = profileImageProps;

        if (displayName === 'anonymous') return renderProfileImage();

        const _linkProps = mergeProps(
            {
                className: 'shrink-0',
                to: `/${ensureTokenUrl(tokenName)}/author/${displayName}`,
            },
            linkProps
        );

        return <Link {..._linkProps}>{renderProfileImage()}</Link>;
    }

    function renderProfileImage() {
        return <ProfileImage {...profileImageProps} />;
    }

    return renderContent();
};

export default ProfileImageWithLink;
